import { projectStore } from '@/store/project-store';

// Checks permission regarding topic (e.g. creating thought, etc.)
export default function () {
  /**
   * returns correct label to use for topic (used as input field labels for example)
   * @returns string
   */
  function topicLabel() {
    const project = projectStore.getState().project;
    if (project?.config?.topic_term) {
      switch (project.config.topic_term) {
        case 'diskussion':
          return 'Diskussion';
        case 'thema':
          return 'Thema';
        case 'bereich':
          return 'Bereich';
        case 'kategorie':
          return 'Kategorie';
        case 'ortsbezug':
          return 'Ortsbezug';
        case 'art_der_eingabe':
          return 'Art der Eingabe';
        case 'zeitpunkt_des_verfahrens':
          return 'Zeitpunkt des Verfahrens';
        default:
          return 'Diskussion';
      }
    }
    return 'Diskussion';
  }
  /**
   * returns correct not-found error message to use for topic
   * @returns string
   */
  function topicNotFound() {
    return topicLabel() + ' wurde nicht gefunden.';
  }
  /**
   * returns correct translation for "to topic" (used as generic label to open a topic)
   * @returns string
   */
  function topicGoTo() {
    const project = projectStore.getState().project;
    let pre_string = 'Zur ';
    if (project?.config?.topic_term) {
      switch (project.config.topic_term) {
        case 'thema':
        case 'bereich':
        case 'ortsbezug':
        case 'zeitpunkt_des_verfahrens':
          pre_string = 'Zum ';
          break;
        default:
          pre_string = 'Zur ';
      }
    }
    return pre_string + topicLabel();
  }
  /**
   * returns correct translation for "in this topic" (used in sentences for voting messages)
   * @returns string
   */
  function topicInThis() {
    const project = projectStore.getState().project;
    let pre_string = 'dieser ';
    if (project?.config?.topic_term) {
      switch (project.config.topic_term) {
        case 'thema':
        case 'bereich':
        case 'ortsbezug':
        case 'zeitpunkt_des_verfahrens':
          pre_string = 'diesem ';
          break;
        default:
          pre_string = 'dieser ';
      }
    }
    return pre_string + topicLabel();
  }

  return {
    topicLabel,
    topicNotFound,
    topicGoTo,
    topicInThis,
  };
}
